export default __webpack_public_path__ + "static/media/plantation_harvesting_c.32dea558.mp4";